import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "custom-form-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "将", -1)
const _hoisted_3 = { style: {"width":"300px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "修改为", -1)
const _hoisted_5 = { style: {"width":"300px"} }
const _hoisted_6 = { class: "operation-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_OioDateTimePicker = _resolveComponent("OioDateTimePicker")!
  const _component_minus_circle_outlined = _resolveComponent("minus-circle-outlined")!
  const _component_plus_circle_outlined = _resolveComponent("plus-circle-outlined")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oio_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleBatchEditBtnClick()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("批量修改")
      ]),
      _: 1
    }),
    _createVNode(_component_oio_modal, {
      visible: _ctx.batchEditModalVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batchEditModalVisible) = $event)),
      title: "批量修改",
      width: "medium"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_oio_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.batchEditModalVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_oio_button, {
          type: "primary",
          onClick: _ctx.onSubmitBatchEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editModalDataList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-row",
            key: item.id
          }, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: item.type,
                "onUpdate:value": ($event: any) => ((item.type) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                options: _ctx.displayEditTypeOptions,
                getPopupContainer: _ctx.getPopupContainer,
                onSelect: _ctx.typeChange
              }, null, 8, ["value", "onUpdate:value", "options", "getPopupContainer", "onSelect"])
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (item.type && ['accountTimeRule'].includes(item.type))
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 0,
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    getPopupContainer: _ctx.getPopupContainer,
                    placeholder: "不修改",
                    style: {"width":"100%"},
                    "default-active-first-option": false,
                    options: _ctx.timeRuleOptions,
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    onSelect: _ctx.itemSelect
                  }, null, 8, ["getPopupContainer", "options", "value", "onUpdate:value", "onSelect"]))
                : (item.type && ['paymentDays'].includes(item.type))
                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                      key: 1,
                      value: item.value,
                      "onUpdate:value": ($event: any) => ((item.value) = $event),
                      class: "oio-input-number num-input",
                      placeholder: "不修改"
                    }, null, 8, ["value", "onUpdate:value"]))
                  : (item.type && ['accountDate'].includes(item.type))
                    ? (_openBlock(), _createBlock(_component_OioDateTimePicker, {
                        key: 2,
                        value: item.value,
                        "onUpdate:value": ($event: any) => ((item.value) = $event),
                        placeholder: "不修改"
                      }, null, 8, ["value", "onUpdate:value"]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createVNode(_component_minus_circle_outlined, {
                onClick: ($event: any) => (_ctx.removeEditModalRow(item.id))
              }, null, 8, ["onClick"]), [
                [_vShow, _ctx.editModalDataList.length > 1]
              ]),
              _withDirectives(_createVNode(_component_plus_circle_outlined, { onClick: _ctx.addEditModalRow }, null, 8, ["onClick"]), [
                [_vShow, index === _ctx.editModalDataList.length - 1 && index !== _ctx.displayEditTypeOptions.length - 1]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}